/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Happy_Light_Puma_LickInputs */

const en_happy_light_puma_lick = /** @type {(inputs: Happy_Light_Puma_LickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Survey token reactivated`)
};

const de_happy_light_puma_lick = /** @type {(inputs: Happy_Light_Puma_LickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token reaktiviert`)
};

/**
* | output |
* | --- |
* | "Survey token reactivated" |
*
* @param {Happy_Light_Puma_LickInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const happy_light_puma_lick = /** @type {((inputs?: Happy_Light_Puma_LickInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Light_Puma_LickInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_happy_light_puma_lick(inputs)
	return de_happy_light_puma_lick(inputs)
});